var _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraySkeletonLines = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 211,
    height: 92,
    viewBox: "0 0 211 92",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 211,
    height: 12,
    rx: 4,
    fill: "#F1F1F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 211,
    height: 12,
    rx: 4,
    fill: "#F1F1F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 40,
    width: 211,
    height: 12,
    rx: 4,
    fill: "#F1F1F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 60,
    width: 211,
    height: 12,
    rx: 4,
    fill: "#F1F1F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 80,
    width: 211,
    height: 12,
    rx: 4,
    fill: "#F1F1F2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraySkeletonLines);
export default ForwardRef;